import type { SignupSchema } from '@repo/schemas/auth/signup';

import { baseErrorMessages } from '@repo/lib/messages/baseErrorMessages';
import { useMutation } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import { AuthService } from './authService';

export function usePostSignup() {
  const signupMutation = useMutation({
    mutationFn: (data: SignupSchema) => AuthService.postSignup(data).then((response) => response.data),
  });

  const errorMessage = useErrorMessage(signupMutation.error, baseErrorMessages);

  return {
    ...signupMutation,
    errorMessage,
  };
}
